import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useAppContext } from "../AppContext";
import Select, { SingleValue } from "react-select";
import { baseStyles, darkThemeStyles } from "./selectorStyles";
import { VersionType } from "../constants";

const Versions: React.FC = () => {
  const { versions, setVersions, colorMode, query, handleSubmit, isEnglish } = useAppContext();

  const handleSelect = (selectedOption: SingleValue<VersionOption>) => {
    if (!selectedOption) return;
    // TODO: Update this to support multiple versions in the future
    const newVersions = [selectedOption.value];
    setVersions(newVersions);
    if (query) {
      handleSubmit(newVersions, query);
    }
  };

  type VersionOption = {
    value: VersionType;
    label: string;
  };

  const options: VersionOption[] = [
    { value: VersionType.ZHCN, label: "简体和合本" },
    { value: VersionType.ZHTW, label: "繁體和合本" },
    { value: VersionType.ESV, label: "ESV" },
  ];

  const versionMap: Record<VersionType, VersionOption> = {
    [VersionType.ZHCN]: { value: VersionType.ZHCN, label: "简体和合本" },
    [VersionType.ZHTW]: { value: VersionType.ZHTW, label: "繁體和合本" },
    [VersionType.ESV]: { value: VersionType.ESV, label: "ESV" },
  };

  const defaultOption = versionMap[versions[0] as VersionType] ?? versionMap[VersionType.ZHCN];

  return (
    <Flex align="center" justify="space-between">
      <Text fontSize="lg" as="b">
        {isEnglish ? `Version:` : "譯本："}
      </Text>
      <div style={{ width: "200px" }}>
        <Select
          options={options}
          onChange={handleSelect}
          isSearchable={false}
          defaultValue={defaultOption}
          styles={{
            ...baseStyles,
            ...(colorMode === "dark" ? darkThemeStyles : {}),
            // You can include light theme styles here as well, if needed
          }}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
        />
      </div>
    </Flex>
  );
};

export default Versions;
